export const GENERAL_CONFIG_LIST = "GENERAL_CONFIG_LIST";
export const HISTORY_GENERAL_CONFIG_LIST = "HISTORY_GENERAL_CONFIG_LIST";
